<template>
  <el-dialog
      width="60%"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      :title="$t('admin.holidayPeriods.viewHolidayPeriod')"
      class="dialog-with-cols"
      append-to-body
  >
    <el-row class="holiday-row">
      <el-col :md="24" :sm="12" :xs="12">
        <label class="span-small-list holiday-label">{{ $t('admin.holidayPeriods.name') }}</label>
        <span class="span-small-list">{{ currentRow.name }}</span>
      </el-col>
    </el-row>
    <el-row class="holiday-row">
      <el-col :md="6" :sm="12" :xs="12">
        <label class="span-small-list holiday-label">{{ $t('admin.holidayPeriods.regions') }}</label>
        <span class="span-small-list">{{ getRegionNames(currentRow.regionIds) }}</span>
      </el-col>
      <el-col :md="6" :sm="12" :xs="12">
        <label class="span-small-list holiday-label">{{ $t('admin.holidayPeriods.effectiveDate') }}</label>
        <span class="span-small-list">{{ currentRow.effectiveDate | moment("MM/DD/YYYY") }}</span>
      </el-col>
      <el-col :md="6" :sm="12" :xs="12">
        <label class="span-small-list holiday-label">{{ $t('admin.holidayPeriods.expirationDate') }}</label>
        <span class="span-small-list">{{ currentRow.expirationDate | moment("MM/DD/YYYY") }}</span>
      </el-col>
      <el-col :md="6" :sm="12" :xs="12">
        <label class="span-small-list holiday-label">{{ $t('admin.holidayPeriods.earlyAccess') }}</label>
        <span class="span-small-list">{{ currentRow.earlyAccess ? $t('common.yes') : $t('common.no') }}</span>
      </el-col>
    </el-row>
    <el-row class="holiday-row">
      <el-col :md="6" :sm="12" :xs="12">
        <label class="span-small-list holiday-label">{{ $t('daysOfService.management.createdBy') }}</label>
        <span class="span-small-list">{{ currentRow.createdByUsername }}</span>
      </el-col>
      <el-col :md="6" :sm="12" :xs="12">
        <label class="span-small-list holiday-label">{{ $t('daysOfService.management.createdAt') }}</label>
        <span class="span-small-list">{{ currentRow.auditCreationDate | moment("MM/DD/YYYY HH:mm") }}</span>
      </el-col>
      <el-col :md="6" :sm="12" :xs="12">
        <label class="span-small-list holiday-label">{{ $t('daysOfService.management.lastModified') }}</label>
        <span class="span-small-list">{{ currentRow.lastUpdatedByUsername }}</span>
      </el-col>
      <el-col :md="6" :sm="12" :xs="12">
        <label class="span-small-list holiday-label">{{ $t('daysOfService.management.lastModifiedAt') }}</label>
        <span class="span-small-list">{{ currentRow.auditLastUpdate | moment("MM/DD/YYYY HH:mm") }}</span>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'HolidayPeriodDetailDialog',
  data() {
    return {
      dialogVisible: false,
    };
  },
  computed: {
    ...mapState({
      currentRow: state => state.holidayPeriods.currentRow,
      regions: state => state.holidayPeriods.regions
    })
  },
  methods: {
    showDialog() {
      this.dialogVisible = true;
    },
    getRegionNames(regionIds) {
      if (!regionIds || !regionIds.length) return '-';
      return regionIds
        .map(id => this.regions.find(r => r.id === id)?.code)
        .filter(code => code)
        .join(', ');
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.holiday-label {
  min-height: 12px;
}

.holiday-row {
  margin-bottom: 20px;
}
</style>
